// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiUrl: "https://etliapiUAT.edelweisstokio.in/api",
  //  apiUrl: "http://192.168.43.62:4200/api",
  //apiUrl: "https://pivcwebuat.edelweisslife.in/api",
  apiUrl: "https://pivcweb.edelweisslife.in/api",
  //apiUrl:'https://apis.edelweisslife.in/api',
  SECRET: 'getg663ghhjjwhyjybgt12121aA5647347',
  pivcId: 'QHtrJNr6iYkAwhaIC1gV7A==',
  communicationID: 'HBhEIgNCmNqAdFQ8/xzGuw=='
};  

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
